import axios, { AxiosHeaders } from 'axios';
import { getPreviewConfig, getPreviewSecret } from '@/utils/preview';

/**
 * @description Create Axios instance
 * @returns {AxiosInstance}
 */

const client = axios.create({
  baseURL: import.meta.env.VITE_CMS_PUBLIC_URL,
  timeout: 10000,
});

client.interceptors.request.use((requestConfig) => {
  const method = requestConfig.method?.toLowerCase() ?? 'get';
  let nextConfig = requestConfig;

  // Content-Type on GET triggers a CORS preflight cross-origin.
  if (requestConfig.headers) {
    const headers = AxiosHeaders.from(requestConfig.headers);

    if (method === 'get') {
      headers.delete('Content-Type');
      headers.delete('content-type');
      nextConfig = { ...nextConfig, headers };
    } else if (!headers.has('Content-Type')) {
      headers.set('Content-Type', 'application/json');
      nextConfig = { ...nextConfig, headers };
    }
  }

  const preview = getPreviewConfig();

  if (!preview.active) {
    return nextConfig;
  }

  const previewSecret = getPreviewSecret();

  if (!previewSecret) {
    return nextConfig;
  }

  return {
    ...nextConfig,
    params: {
      ...nextConfig.params,
      status: preview.status,
      previewSecret,
    },
  };
});

export default client;
